import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { HttpUtilService } from './../../services/http-util.service';
import { API_JAVA_CONSULTA_HISTORICO_MAQUINA } from './../../app.api';
import { HistoricoMaquinaModel } from './../../model/historico-maquina.model';

@Component({
  selector: 'app-historico-maquina',
  templateUrl: './historico-maquina.component.html',
  styleUrls: ['./historico-maquina.component.css']
})
export class HistoricoMaquinaComponent implements OnInit {

  isFetching: boolean;
  nome: string;
  dataSource = new MatTableDataSource<HistoricoMaquinaModel>();
  displayedColumns: string[] = ['situacao', 'dataAlteracao'];
  
  // Pagination
  paginacao: boolean;
  length:number;
  pageIndex:number = 0;
  pageSize:number = 5;
  pageSizeOptions:number[] = [5, 10, 25, 50, 100];

  constructor(private dialogRef: MatDialogRef<HistoricoMaquinaComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private httpUtilService: HttpUtilService) { }

  ngOnInit() {
    this.nome = this.data.maquina.nomeMaquina;
    this.consultar(null);
  }

  private consultar($event): void {
    this.isFetching = true;
    this.httpUtilService.get(`${API_JAVA_CONSULTA_HISTORICO_MAQUINA}?${this.montarParametros($event)}`).subscribe(resp => {
      this.dataSource.data = resp.data;
      this.length = resp.quantidadeLinhas;
       this.isFetching = false;
    });
  }

  private montarParametros($event): string {

    let linhaInicial = 0;
    let linhaFinal = this.pageSize;
    
    if($event) {
      this.pageIndex = $event.pageIndex;
      this.pageSize = $event.pageSize;

      const itemPagina = ($event.pageIndex * $event.pageSize);
  
      linhaInicial = (itemPagina + 1);
      linhaFinal = (itemPagina + $event.pageSize) > $event.length ? $event.length : (itemPagina + $event.pageSize);
    }

    return`inscricaoResponsavel=${this.data.maquina.inscricaoResponsavel}&chaveMaquina=${this.data.maquina.chaveMaquina}&linhaInicial=${linhaInicial}&linhaFinal=${linhaFinal}`;
  }

  pesquisar($event) {
    this.consultar($event);
  }
}
